export const formatDateString = (value: string) => {
  if (value && value !== "") {
    const localdate = new Date(value);
    return `${localdate.getUTCFullYear()}-${String(
      localdate.getUTCMonth() + 1
    ).padStart(2, "0")}-${String(localdate.getUTCDate()).padStart(2, "0")}`;
  }
  return "";
};
